<template>
  <div class="flex items-center gap-3">
    <NButton variant="flat" color="gray" class="flex-1" @click="remove()">
      <NText variant="caption1" weight="bold">
        {{ t('common.refuse') }}
      </NText>
    </NButton>

    <NButton
      variant="fill"
      color="red"
      class="flex-1"
      :disabled="loadingDeleteWithdrawal"
      :loading="loadingDeleteWithdrawal"
      @click="handleDeleteWithdrawal"
    >
      <NText variant="caption1" weight="bold">
        {{ t('common.cancelRequest') }}
      </NText>
    </NButton>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useDialog } from '@negar/core';

const emit = defineEmits<{
  (e: 'deleteWithdrawal'): void;
}>();

defineProps<{
  loadingDeleteWithdrawal: boolean;
}>();

const { t } = useI18n();

const { remove } = useDialog();

const handleDeleteWithdrawal = () => {
  emit('deleteWithdrawal');

  remove();
};
</script>
